module.exports = __webpack_public_path__ + "827b7543a10d5e8d75cdda940658e75d.jpg";